<template>
  <div class="poi-messages">
    <!-- Loading Indicator -->
    <div v-if="poiLoading" class="alert alert-info">
      <i class="fas fa-spinner fa-spin"></i> Loading points of interest...
    </div>
    
    <!-- No Results Message -->
    <div v-else-if="poiMessages.noResults" class="alert alert-warning">
      <i class="fas fa-info-circle"></i> No points of interest found in this area. Try zooming out or moving the map.
    </div>
    
    <!-- Error Message -->
    <div v-else-if="poiMessages.error" class="alert alert-danger">
      <i class="fas fa-exclamation-triangle"></i> {{ poiMessages.error }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'POIMessages',
  computed: {
    poiLoading() {
      return this.$store.state.creSiteIQ.poiLoading;
    },
    poiMessages() {
      return this.$store.state.creSiteIQ.poiMessages || {};
    }
  }
};
</script>

<style scoped>
.poi-messages {
  position: fixed;
  bottom: 20px;
  left: 20px;
  z-index: 1000;
  max-width: 400px;
  pointer-events: none;
}

.alert {
  margin-bottom: 10px;
  padding: 10px 15px;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  pointer-events: auto;
}

.alert i {
  margin-right: 8px;
}

.alert-info {
  background-color: #d1ecf1;
  color: #0c5460;
  border: 1px solid #bee5eb;
}

.alert-warning {
  background-color: #fff3cd;
  color: #856404;
  border: 1px solid #ffeeba;
}

.alert-danger {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}
</style>
